import { render, staticRenderFns } from "./ClassAction.vue?vue&type=template&id=11378037&scoped=true&"
import script from "./ClassAction.vue?vue&type=script&lang=js&"
export * from "./ClassAction.vue?vue&type=script&lang=js&"
import style0 from "./ClassAction.vue?vue&type=style&index=0&id=11378037&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11378037",
  null
  
)

export default component.exports